import React, { useEffect, useState } from "react";
import classes from "./Banner.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";

interface BannerProps {
  children: React.ReactNode;
  bannerData: any;
  bgInverted?: boolean;
  bannerStyles?: React.CSSProperties;
  imageWrapperStyles?: React.CSSProperties;
}

const Banner = ({ children, bannerData, bgInverted = false, bannerStyles = {}, imageWrapperStyles={} }: BannerProps) => {
  const isMobile = useIsMobile(768);
  const bannerImageData = !isMobile ? bannerData?.priorityImage : bannerData?.priorityImageMobile;
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    setAspectRatio(null);
    const url = bannerImageData?.url;
    if (isMobile || !url) return;

    const img = new window.Image();
    const onLoad = () => {
      if (img.naturalWidth && img.naturalHeight) {
        setAspectRatio(img.naturalWidth / img.naturalHeight);
      }
    };
    img.addEventListener("load", onLoad);
    img.src = url;
    return () => img.removeEventListener("load", onLoad);
  }, [bannerImageData?.url, isMobile]);

  const imageClickHandler = (url: string) => () => {
    window.open(url ?? "", "_blank");
  };

  return (
    <>
      {bannerImageData?.url ? (
        <div
          className={classes["image-wrapper"]}
          style={{ background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)", ...imageWrapperStyles }}
          onClick={imageClickHandler(bannerData?.priorityImageUrl ?? "")}
        >
          <div
            className={classes["priority-image-container"]}
            style={!isMobile && aspectRatio ? { aspectRatio: String(aspectRatio), height: "auto" } : undefined}
          >
            <CustomImage
              src={(bannerImageData?.url ?? "/images/man_with_foldedhands.png") as string}
              alt={bannerData?.title ?? "banner-image"}
              layout="fill"
              objectFit={isMobile ? "fill" : "contain"}
              className={classes["priority-image"]}
              priority
              isLazyLoad={false}
            />
          </div>
        </div>
      ) : (
        <div className={classes["banner-container-wrapper"]} style={{ background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)" }}>
          <div className={classes["banner-container"]} style={bannerStyles}>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Banner;
